/**
 * Chemistry Algorithm Constants
 *
 * Can't wait for ECMA 6
 */

// Switch to anon and it just works!
/**
 * @module
 */
define(function () {
    var instance = null;
    /**
     * @class Constants
     */
    function Constants() {

        this.REACTION_BRACKET_ACCURACY = 1.0e-24; // 1e-24 moles should be enough
        this.CP_OF_WATER = 1.0;
        this.DQ = 10000.0;
        this.PRETTY_SMALL_NUMBER = 1.0e-15;
        this.MINIMUM_CONCENTRATION = 1.0e-20;
        this.ROUNDOFF_TOLERANCE = 1.0e-13;
        this.SIMILARITY_RELATIVE_TOLERANCE = 1.0e-6;

        this.R = 0.00831451;

        this.TZERO = 273.15;
        this.ROOM_TEMPERATURE = 298.15;
        this.FREEZING_POINT_OF_WATER = 273.15;
        this.BOILING_POINT_OF_WATER = 373.15;

        this.FREEZING_DEPRESSION_CONST_WATER = 1.858;
        this.BOILING_ELEVATION_CONST_WATER = 0.512;

        this.MW_OF_WATER = 18.1053;

        this.SOLID_DENSITY = 2.0;
        this.DENSITY_OF_WATER = 1.0;

        this.CAL_TO_J = 4.184;

        this.MIN_WAVELENGTH = 300;
        this.MAX_WAVELENGTH = 800;

    };
    Constants.getInstance = function() {
        if(instance === null) {
            instance = new Constants();
        }
        return instance;
    };
    return Constants.getInstance();
});
